module.exports = __webpack_public_path__ + "img/PG1_1-7-259x195.3a6c86d3.png";